const tableStyle = { maxHeight: 300, overflowY: 'auto' };

export { tableStyle };
